import { render, staticRenderFns } from "./PaymentSettings.vue?vue&type=template&id=0369b66e&scoped=true"
import script from "./PaymentSettings.vue?vue&type=script&lang=js"
export * from "./PaymentSettings.vue?vue&type=script&lang=js"
import style0 from "./PaymentSettings.vue?vue&type=style&index=0&id=0369b66e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0369b66e",
  null
  
)

export default component.exports